import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { setUserType } from "../../../redux/actions";
import { COLORS } from "../../../assets/colors";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function RoleSelectionModal() {
  const dispatch = useDispatch();
  const { isAuthenticated, currentUser } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);

  // Show if logged in, verified, NOT an admin, and user_type is null
  const isOpen = Boolean(
    isAuthenticated && 
    currentUser && 
    currentUser.otp_verified && 
    !currentUser.isAdmin && 
    !currentUser.user_type
  );

  const handleSelection = async (type) => {
    setLoading(true);
    await dispatch(setUserType(type));
    setLoading(false);
  };

  if (!isOpen) return null;

  return (
    <Dialog
      open={isOpen}
      TransitionComponent={Transition}
      keepMounted
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
    >
      <StyledDialogContent>
        <Header>
          <h2>Welcome to GoSawari! 👋</h2>
          <p>How are you planning to use the app?</p>
        </Header>

        <OptionsContainer>
          <OptionCard onClick={() => !loading && handleSelection("passenger")} disabled={loading}>
            <div className="icon">🧳</div>
            <h3>I'm a Passenger</h3>
            <p>I want to find rides and travel comfortably.</p>
          </OptionCard>

          <OptionCard onClick={() => !loading && handleSelection("driver")} disabled={loading}>
            <div className="icon">🚗</div>
            <h3>I'm a Driver</h3>
            <p>I want to offer rides and earn money.</p>
          </OptionCard>

          <OptionCard onClick={() => !loading && handleSelection("both")} disabled={loading} className="both">
            <div className="icon">🔄</div>
            <h3>I do both</h3>
            <p>I want to switch between driving and riding.</p>
          </OptionCard>
        </OptionsContainer>
      </StyledDialogContent>
    </Dialog>
  );
}

const StyledDialogContent = styled(DialogContent)`
  && {
    padding: 2.5rem;
    background: #fdfdfd;
    
    @media (max-width: 600px) {
      padding: 1.5rem;
    }
  }
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 2rem;

  h2 {
    color: ${COLORS.primaryColor};
    font-size: 1.8rem;
    font-weight: 700;
    margin-bottom: 0.5rem;
  }

  p {
    color: ${COLORS.secondaryTextColor};
    font-size: 1.1rem;
  }
`;

const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const OptionCard = styled.div`
  display: flex;
  align-items: center;
  padding: 1.25rem;
  border: 2px solid ${COLORS.borderColor};
  border-radius: 16px;
  cursor: ${(props) => (props.disabled ? "wait" : "pointer")};
  transition: all 0.2s ease;
  background: white;
  opacity: ${(props) => (props.disabled ? 0.7 : 1)};

  &:hover {
    border-color: ${COLORS.primaryColor};
    background: #f0fdfa;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(5, 71, 82, 0.1);
  }

  &.both {
    background: linear-gradient(to right, #fdfbfb 0%, #ebedee 100%);
    &:hover {
      background: linear-gradient(to right, #f0fdfa 0%, #e6fffa 100%);
    }
  }

  .icon {
    font-size: 2.5rem;
    margin-right: 1.25rem;
    background: rgba(5, 71, 82, 0.05);
    height: 60px;
    width: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
  }

  h3 {
    margin: 0 0 0.25rem 0;
    color: ${COLORS.primaryColor};
    font-size: 1.2rem;
  }

  p {
    margin: 0;
    color: ${COLORS.secondaryTextColor};
    font-size: 0.9rem;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    text-align: center;
    
    .icon {
      margin-right: 0;
      margin-bottom: 1rem;
    }
  }
`;
